import { IMarkedListItemText } from 'shared/types/seoMarkedList';
import { IPreloadedState } from '../../types/redux';

export const selectMarkedListItems = (state: IPreloadedState): IMarkedListItemText[] => {
  return state.seoMarkedList.items;
};
